import React, { useEffect, useState } from "react";
import SelectAutocomplete from "common/SelectAutocomplete.jsx";
import Request from "common/Request";
import { parsePolicyNames, policiesRetrieval } from "../api.js";
import { useBqnId, useClusterStatus } from "common/BqnContext.jsx";

// The response keeps its BQN column, so the policies of the BQN selected are
// taken from it whether the whole cluster answers or only that BQN.
const loadPolicyNames = (mode, bqnId) =>
  policiesRetrieval(mode, bqnId)
    .then(response => parsePolicyNames(response, bqnId))
    .then(names => Array.from(new Set(names)));

const nameAsLabelAndValue = (names) =>
  names.map((name) => ({ label: name, value: name }));

const asOptions = (policies) => ({
  options: [{ value: "all", label: "All policies" }, ...policies],
});

const PolicyInput = ({ name, selected, onChange }) => {
  const [request, setRequest] = useState();
  const bqnId = useBqnId();
  const mode = useClusterStatus()?.mode;

  useEffect(() => {
    if (bqnId === undefined) {
      return;
    }

    doLoad();
  }, [mode, bqnId])

  function doLoad(){
    setRequest(
      loadPolicyNames(mode, bqnId).then(nameAsLabelAndValue).then(asOptions)
    )
  }

  return <Request during={request}>
    {({ options = [] }) => (
      <SelectAutocomplete
        title="Policies"
        icon="folder_open"
        options={options}
        name={name}
        selected={selected}
        onChange= {(value)=> onChange(value, "policy")}
      />
    )}
  </Request>
};

export default PolicyInput;
